/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const TabIndicatorSvg = () => (
  <svg width="78" height="192" viewBox="0 0 78 192" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_10880_3520)">
      <path d="M78 30C78 38.8366 70.8366 46 62 46H78V30Z" fill="white"/>
      <path d="M30 62C30 53.1634 37.1634 46 46 46H78V146H46C37.1634 146 30 138.837 30 130V62Z" fill="white"/>
      <path d="M63 100C64.1 100 65 100.9 65 102C65 103.1 64.1 104 63 104C61.9 104 61 103.1 61 102C61 100.9 61.9 100 63 100ZM57.6211 91.707L53.3281 96L57.6211 100.293L56.207 101.707L50.5 96L56.207 90.293L57.6211 91.707ZM63 94C64.1 94 65 94.9 65 96C65 97.1 64.1 98 63 98C61.9 98 61 97.1 61 96C61 94.9 61.9 94 63 94ZM63 88C64.1 88 65 88.9 65 90C65 91.1 64.1 92 63 92C61.9 92 61 91.1 61 90C61 88.9 61.9 88 63 88Z" fill="#62698C"/>
      <path d="M78 162C78 153.163 70.8366 146 62 146H78V162Z" fill="white"/>
    </g>
    <defs>
      <filter id="filter0_d_10880_3520" x="0" y="0" width="108" height="192" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="15"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.384314 0 0 0 0 0.411765 0 0 0 0 0.54902 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10880_3520"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10880_3520" result="shape"/>
      </filter>
    </defs>
  </svg>

);

export const TabIndicatorIcon = (props) => <Icon component={TabIndicatorSvg} {...props} />;
